module.exports = __webpack_public_path__ + "static/media/image-not-found.764d65c1.jpg";